import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

/**
 * Handles which dashboard is shown to user
 */
@Component({
  name: 'StatusPage',
})
export default class DashboardHandler extends Vue {
  @Prop() private readonly statusCode: number | undefined;
  @Prop() private readonly statusTextKey: string | undefined;
  @Prop() private readonly showHomeButton: boolean | undefined;

  get isCoach(): boolean {
    return this.$store.getters.isCoach;
  }

  get isApprentice(): boolean {
    return this.$store.getters.isApprentice;
  }
}
